import { createSlice } from "@reduxjs/toolkit";
const userItemsFromStorage = JSON.parse(localStorage.getItem("persist:root"))
	? JSON.parse(localStorage.getItem("persist:root"))?.userLogin
	: {};

const userSlice = createSlice({
	name: "user",
	initialState: userItemsFromStorage,
	reducers: {
		loginStart: (state) => {
			state.loading = true;
		},
		loginSuccess: (state, action) => {
			state.loading = false;
			state.userInfo = action.payload;
			state.error=false;
			state.success = true;
			console.log(state.userInfo);
		},
		loginFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		logout: (state) => {
			state.userInfo = {};
		},
		loginReset:(state,action)=>{
			state.error=false
			state.success = false;
		}
	},
});

export const { loginStart, loginSuccess, loginFailure, logout,loginReset } =
	userSlice.actions;
export default userSlice.reducer;
